// extracted by mini-css-extract-plugin
export default {"panel":"simple_panel__rQUXE"};